import React from 'react'
import { MENSAGEM_NCM_INEXISTENTE } from '../../hooks/useNcmTextoPendente'
import { Mensagem } from './style'

interface NcmErroCampoProps {
  visivel: boolean
}

export default function NcmErroCampo({ visivel }: NcmErroCampoProps): React.ReactElement | null {
  return visivel ? <Mensagem role="alert">{MENSAGEM_NCM_INEXISTENTE}</Mensagem> : null
}
